import React from "react";

import SrrRowBase from "./SrrRowBase";

const warrantyRepairMonthOfControl = ({ row, items, group }) => {
  const dealerArr = ["DealerName", "INN", "ent_id", "subject", "FO", "city"];
  const cityArr = ["city", "subject", "FO"];
  const foArr = ["FO"];
  const regionArr = ["subject", "FO"];
  let optionsTable = [];

  switch (group["group"]) {
    case "dealer":
      optionsTable = dealerArr.map((el) => row[el]);
      break;
    case "city":
      optionsTable = cityArr.map((el) => row[el]);

      break;
    case "fo":
      optionsTable = foArr.map((el) => row[el]);

      break;
    case "region":
      optionsTable = regionArr.map((el) => row[el]);
      break;
  }

  const renderItem = Object.keys(row)
    .map((key) => {
      if (group["arrGO"].includes(key)) {
        let serviceCount = row[key]?.cars.length;
        let percent = 0;
        if (row[key]?.saleCount > 0 && serviceCount > 0) {
          percent = (serviceCount / row[key]?.saleCount) * 100;
        }
        return [row[key]?.saleCount, serviceCount, percent.toFixed(2)];
      }
    })
    .filter((value) => value !== undefined);

  return <SrrRowBase leadingCells={optionsTable} cells={renderItem} />;
};

export default warrantyRepairMonthOfControl;
